import { memo } from 'react'
import { ClockIcon } from '@heroicons/react/24/outline'
import SightingCard from '../../SightingCard'
import LoadingSpinner from '../../LoadingSpinner'
import CollapsibleSection from './CollapsibleSection'
import PaginationControls from './PaginationControls'

/**
 * RecentSightingsSection - User's recent sightings display
 * Shows paginated list of sightings the user has reported
 */
const RecentSightingsSection = memo(function RecentSightingsSection({
  isExpanded,
  onToggle,
  sightings,
  loading,
  currentPage,
  onPageChange,
  itemsPerPage,
  userLocation,
  t
}) {
  const totalPages = Math.ceil(sightings.length / itemsPerPage)
  const paginatedSightings = sightings.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  )

  return (
    <CollapsibleSection
      title={t('profile.recentSightings')}
      icon={ClockIcon}
      count={sightings.length}
      isExpanded={isExpanded}
      onToggle={onToggle}
      tooltip={t('profile.tooltips.recentSightingsSection', 'Summary of your recent vendor sightings. Click to expand and view details.')}
      iconColor="text-primary-400"
      badgeColor="bg-primary-100 text-primary-700"
    >
      {loading ? (
        <LoadingSpinner size="sm" />
      ) : sightings.length === 0 ? (
        <div className="p-3 text-center text-xs text-gray-500">
          {t('profile.noSightingsYet')}
        </div>
      ) : (
        <>
          <div className="space-y-2 p-2">
            {paginatedSightings.map((sighting) => (
              <SightingCard 
                key={sighting.id} 
                sighting={sighting}
                userLocation={userLocation}
              />
            ))}
          </div>
          <PaginationControls
            currentPage={currentPage}
            totalPages={totalPages}
            onPageChange={onPageChange}
            t={t}
          />
        </>
      )}
    </CollapsibleSection>
  )
})

export default RecentSightingsSection
